import styled from '@emotion/styled';

export const BtnContainer = styled('div')({
  display: 'flex',
  gap: 3,
});
